export const queueViewRouteDef = [
    {
        path: ':id/:resource/queue-view',
        component: 'QueueViewComponent',
        data: {
            selector: 'kx-queue-view',
        }
    },
    {
        path: 'generate-token',
        component: 'GenerateTokenComponent',
        data: {
            selector: 'kx-generate-token',
        }
    },
    {
        path: ':id/:resource/token-view',
        component: 'ViewTokenComponent',
        data: {
            selector: 'kx-view-token',
        }
    },
    {
        path: ':id/:resource/package-token-view',
        component: 'PackageTokenScreenComponent',
        data: {
            selector: 'app-package-token-screen',
        }
    },
    {
        path: ':id/:resource/appt-token-view',
        component: 'AppointmentTokenTvViewComponent',
        data: {
            selector: 'app-appointment-token-tv-view',
        }
    },
    {
        path: 'par-token-screen/view',
        component: 'ParTokenScreenComponent',
        data: {
            selector: 'app-par-token-screen',
        }
    },
    {
        path: ':id/:resource/appointment-token-view',
        component: 'TokenApptQmsComponent',
        data: {
            selector: 'app-token-appt-qms',
        }
    },
    {
        path: 'single-token-view',
        component: 'SingleViewTokenComponent',
        data: {
            selector: 'app-single-view-token',
        }
    },
    {
        path: 'multiple-token-view',
        component: 'SingleViewTokenComponent',
        data: {
            selector: 'app-single-view-token',
        }
    },

    // 9592282206  ViewTokenComponent
    // {
    //     path: ':resource/:returnId/:resource/opdetail',
    //     component: 'DynamicGridWithControlsComponent',
    //     data: {
    //         selector: 'kx-editable-grid'
    //     }
    // }
]


